import { prefix } from './actions';

export const loading = state => state[prefix].loading;
export const listsPage = state => state[prefix].listsPage;
export const sendEmailStatus = state => state[prefix].sendEmailStatus;
export const current = state => state[prefix].current;
export const customEmailsList = state => state[prefix].customEmailsList;
export const listLimit = state => state[prefix].listLimit;
export const listCount = state => state[prefix].listCount;
